import { render, staticRenderFns } from "./CodesForm.vue?vue&type=template&id=8127d0ea&scoped=true&"
import script from "./CodesForm.vue?vue&type=script&lang=js&"
export * from "./CodesForm.vue?vue&type=script&lang=js&"
import style0 from "./CodesForm.vue?vue&type=style&index=0&id=8127d0ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8127d0ea",
  null
  
)

export default component.exports